import React from 'react';

export const BreakoutGroupConfig = {
    settings: {
        layout: {
            config: {
                header: { display: true },
                footer: { display: true },
                navbar: { display: true },
            },
        },
    },
    isPrivate: true,
    eventName: 'breakout_group',
    routes: [
        {
            path: '/:organizationId/:eventSlug/group/:roomId',
            component: React.lazy(() => import('./BreakoutGroup')),
        },
    ],
};
